var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('b-container',[_c('b-row',[_c('b-col',{staticClass:"text-center mt-5 mb-5",attrs:{"cols":"12"}},[_c('router-link',{attrs:{"to":"/"}},[_c('b-img',{attrs:{"alt":"Rabbi IT Firm Logo","width":"220","src":require('@/assets/logo.png')}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }